<template>
  <ZMainPage type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">基础信息</span>
      </div>
      <LineWrapper list column="3" label-width="180rem">
        <LineItem v-for="item in list" :key="item.label" :label="item.label">
          <span>{{ item.value }}</span>
          <span class="text-primary ml-1 c-p" v-if="item.button" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
        <image-viewer :visible.sync="visible" :list="[score_image]" />
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <span class="tags-wrap" v-if="diff_fee_tag">{{ diff_fee_tag }}</span>
        <span class="tags-wrap" v-if="tags">{{ tags }}</span>
      </div>
      <el-form class="content" label-width="180rem" label-position="left" :rules="rules" :model="formData" ref="form">
        <el-row>
          <el-col span="8">
            <el-form-item :label="order_type == 100 ? '应缴金额' : '系统计算应缴总额'">
              {{ formData.sum_compute_price }}
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否缴费" prop="is_pay">
              <el-select v-model="formData.is_pay" placeholder="请选择是否缴费">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8" v-if="order_type === 100 && formData.is_pay === 1">
            <el-form-item label="是否分期" prop="is_by_stages">
              <el-select v-model="formData.is_by_stages" placeholder="请选择是否分期" @change="onStageChange">
                <el-option :value="0" label="否"></el-option>
                <el-option :value="1" label="是"></el-option>
                <el-option :value="2" label="部分欠缴"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="formData.is_pay === 2">
          <el-row>
            <el-col span="12">
              <el-form-item style="margin-bottom: 0"></el-form-item>
              <el-form-item label="驳回原因" prop="reason">
                <el-input v-model="formData.reason" maxlength="300" placeholder="请输入驳回原因" rows="8" show-word-limit="" style="width: 790rem" type="textarea"></el-input>
                <div class="tips-info">
                  <i class="el-icon-warning z-i"></i>
                  <span>驳回后，家长端订单将自动取消，请谨慎操作!</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-row>
            <el-col span="8">
              <el-form-item :label="order_type === 100 ? '实缴金额' : '合计实缴总额'" prop="sum_price">
                <el-input v-model="formData.sum_price" placeholder="请输入本期实缴金额" :disabled="!formData.is_by_stages" @input="onPriceChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="8" v-if="formData.is_by_stages">
              <el-form-item label="欠缴金额" prop="sum_remain_price">
                <el-input v-model="formData.sum_remain_price" placeholder="请输入本期实缴金额" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="formData.is_by_stages === 1">
            <el-col span="8">
              <el-form-item label="分期每期应缴金额" prop="average_price">
                <el-input v-model="formData.average_price" placeholder="请输入分期每期应缴金额" @input="onInstallmentChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="分期期数" prop="installment_count">
                <el-input v-model="formData.installment_count" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="20" v-if="installmentConfig.length">
              <el-form-item label="">
                <CustomTable :config="installmentConfig" :data="installmentData" border />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="showMethod" label="实缴金额及方式" class="z-no-margin-bottom mb-2">
            <div class="z-dynamic-list-item" v-for="(domain, index) in formData.payment_detail" :key="domain.id">
              <div class="flex z-dynamic-list-inner">
                <el-form-item labelWidth="0" :prop="`payment_detail.${index}.paid_amount`" :rules="dynamicNumber">
                  <el-input v-model="domain.paid_amount" placeholder="请输入学生缴费金额"></el-input>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payment_method`" :rules="dynamicSelect">
                  <el-select v-model="domain.payment_method" placeholder="请选择学生缴费方式">
                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payer`" :rules="dynamicInput">
                  <el-input v-model="domain.payer" placeholder="请输入付款人姓名" maxlength="20"></el-input>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item :prop="`payment_detail.${index}.payment_at`" :rules="dynamicData" labelWidth="0">
                  <el-date-picker v-model="domain.payment_at" placeholder="请选择缴费时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </div>
              <el-form-item label-width="40rem">
                <el-button icon="el-icon-delete" circle v-if="formData.payment_detail.length !== 1" @click.prevent="handelRemove(domain)"></el-button>
                <el-button icon="el-icon-plus" circle v-if="formData.payment_detail.length !== dynamicMaxlength && index === formData.payment_detail.length - 1" @click="handleAdd"></el-button>
              </el-form-item>
            </div>
            <ZuTips :value="sumAmount" type="info" showIcon />
          </el-form-item>
          <el-row>
            <el-col span="15">
              <el-form-item label="备注">
                <el-input v-model="formData.remark" maxlength="300" placeholder="请输入" rows="8" show-word-limit type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
    </div>
    <Dialog :visible.sync="dialogVisible1" title="最高诊断性考试成绩详情" size="small" :showFooter="false">
      <LineWrapper label-width="100rem" class="flex flex-column" style="margin-left: 60rem">
        <LineItem :label="item.label" :value="item.value" v-for="item in dialogList" :key="item.label" labelAlign="right"></LineItem>
      </LineWrapper>
    </Dialog>
    <template slot="footer">
      <el-button @click="handleSubmit('form')" type="primary">{{formData.is_pay === 2 ?'驳回' : '通过' }}</el-button>
      <el-button @click="$router.back()">返回</el-button>
    </template>

    <el-dialog :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
      <div style="text-align: center; margin-top: 12rem; font-weight: 700; font-size: 18rem">
        {{ formData.is_pay === 1 ? '是否确认学生缴费完成并通过审批 ?' : '驳回后家长端订单将自动取消，是否确认驳回?' }}
      </div>
      <div slot="footer" style="width: 100%; display: flex; justify-content: space-between; padding: 12rem 128rem">
        <el-button type="primary" @click="handleSure">确 定</el-button>
        <el-button @click="dialogVisible = false">再看看</el-button>
      </div>
    </el-dialog>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ImageViewer from '@/components/common/ImageViewer'
import Dialog from '@/components/common/Dialog'
import ZuTips from '@/components/common/ZuTips'
import CustomTable from '@/components/common/CustomTable'
import http from '@/api'
import { validateNumber, verifyIsNumber } from '@/utils/validate'
import { objectIsEmpty, transformAddOrEditData, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide, numberToChinese, formatDate } from '@/utils'
import { orderPayMethod } from '@/utils/data'

export default {
  _config: { route: { path: 'edit-old', meta: { title: '审批' } } },
  components: { LineWrapper, LineItem, ImageViewer, Dialog, ZuTips, CustomTable },
  data() {
    const v1 = (_r, value, callback) => {
      let v = verifyIsNumber(value, { empty: '请输入实缴金额', positive: true  })
      const n1 = Number(this.formData.sum_compute_price)
      const n2 = Number(value)
      if (!v) {
        if (n2 > n1) v = '实缴金额需小于应缴金额'
      }
      if (v) return callback(new Error(v))
      validateNumber(value, callback, { min: 0, max: n1, equalToMin: true, equalToMax: true })
    }
    const v2 = (_r, value, callback) => {
      const v = verifyIsNumber(value, { empty: '请输入分期每期应缴金额', positive: true  })
      if (v) return callback(new Error(v))
      const n1 = Number(this.formData.sum_remain_price)
      validateNumber(value, callback, { min: 0, max: n1 })
    }
    const v3 = (_r, value, callback) => {
      const v = verifyIsNumber(value, { empty: '请输入分期每期应缴金额', positive: true })
      if (v) return callback(new Error(v))
      if (Number(value) > 12) return callback('超出最大分期限额，分期期数不能超过12期')
      callback()
    }
    return {
      tags: '',
      visible: false,
      dialogVisible1: false,
      dialogList: [],
      diff_fee_tag: '',
      pay_status: '',
      name: '否',
      order_type: 0,
      installmentConfig: [],
      installmentData: [],
      formData: {
        payment_detail: [],
        is_pay: 1,
        is_by_stages: 0,
        sum_compute_price: 0,
        sum_price: 0,
        sum_remain_price: '',
        average_price: '',
        installment_count: '',
        reason: '',
        remark: ''
      },
      loading: false,
      dialogVisible: false,
      rules: {
        is_pay: [{ required: true, message: '请选择是否缴费', trigger: 'change' }],
        reason: [{ required: true, message: '请输入驳回原因', trigger: 'change' }],
        sum_price: [{ required: true, validator: v1, trigger: 'change' }],
        average_price: [{ required: true, validator: v2, trigger: 'change' }],
        installment_count: [{ required: true, validator: v3, trigger: 'change' }],
        payment_method: [{ required: true, message: '请输入缴费方式', trigger: 'change' }],
        payer: [{ required: true, message: '请输入付款人姓名', trigger: 'change' }]
      },
      list: [],
      score_image: '',
      typeOptions: [],
      dynamicMaxlength: 15,
      dynamicSelect: { required: true, message: '请选择学生缴费方式', trigger: 'change' },
      dynamicInput: { required: true, message: '请输入付款人姓名', trigger: 'blur' },
      dynamicData: {required: true, message: '请选择缴费时间', trigger: 'blur'},
      dynamicNumber: { required: true, validator: (_, value, callback) => validateNumber(value, callback, { min: 0, equalToMin: true, empty: '请输入学生缴费金额' }), trigger: 'blur' }
    }
  },
  computed: {
    showMethod() {
      if(this.formData.sum_price !== '') {
        if (Number(this.formData.sum_price) === 0) return false
      }
      return true
    },
    sumAmount() {
      const arr = this.formData.payment_detail.filter((i) => i.paid_amount)
      const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      if (isNaN(sum)) return '请输入数字'
      return `累计实缴金额：${sum}`
    }
  },
  watch: { 
  },
  mounted() {
    this.getConfig()
    this.handleAdd()
    this.getData()
  },
  methods: {
    getConfig() {
      this.typeOptions = orderPayMethod()
    },
    handlePreview(type) {
      if (type === 0) {
        this.visible = true
      } else {
        this.dialogVisible1 = true
      }
    },
    onStageChange(val) {
      if (val) {
        this.formData.sum_price = ''
        this.formData.sum_remain_price = ''
        this.formData.average_price = ''
        this.formData.installment_count = ''
        this.installmentConfig = []
        this.installmentData = []
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['sum_price', 'average_price'])
        })
      }
      else {
        this.formData.sum_price = this.formData.sum_compute_price
      }
    },
    onPriceChange(val) {
      let v = verifyIsNumber(val, { empty: '请输入实缴金额', positive: true  })
      const n1 = Number(this.formData.sum_compute_price)
      const n2 = Number(val)
      if (!v) {
        if (n2 > n1) v = '实缴金额需小于应缴金额'
      }
      if (v) {
        this.formData.sum_remain_price = n1
        return
      } 
      this.formData.sum_remain_price = preciseSubtract(n1, n2)
      if (this.formData.average_price) {
        this.$refs.form.validateField('average_price')
        this.calculateInstallment(this.formData.average_price)
      }
    },
    calculateInstallment(val) {
      const v = verifyIsNumber(val, { positive: true  })
      if (v) {
        this.formData.installment_count = ''
        this.installmentConfig = []
        this.installmentData = []
        return
      }
      const v1 = Number(this.formData.sum_remain_price)
      const v2 = Number(val)
      if (v2 <= 0 || v2 >= v1) {
        this.formData.installment_count = ''
        this.installmentConfig = []
        this.installmentData = []
        return
      }
      const n = Math.ceil(v1/v2)
      this.formData.installment_count = n + 1
      this.changeInstallmentData()
    },
    onInstallmentChange(val) {
      this.calculateInstallment(val)
    },
    changeInstallmentData() {
      const len1 = Number(this.formData.installment_count)
      if (!len1 || len1 > 12) return
      const len = len1 - 1
      const total = Number(this.formData.sum_remain_price)
      const unit = Number(this.formData.average_price)
      const v1 = Number(this.formData.sum_price)
      const num = preciseDivide(total, unit)
      const v3 = len === num ? unit : preciseSubtract(total, preciseMultiply(unit, len - 1))
      const arr1 = []
      const obj = {}
      for (let i = 0; i <= len; i++) {
        const key = `K_${i}`
        obj[key] = i ? i === len ? v3 : unit : v1
        arr1.push({ label: numberToChinese(i+1, true)+'期', prop: key, type: 'title' })
      }
      arr1.push({ label: '合计', prop: `K_${len+1}`, type: 'title' })
      obj[`K_${len+1}`] = preciseAdd(total, this.formData.sum_price)
      this.installmentConfig = arr1
      this.installmentData = [obj]
    },
    getData() {
      http({ url: '/recruit-v2/order-offline/show?id=' + this.$route.query.id, pre: 'zs' }).then((res) => {
        this.formData.sum_price = res.money_answer
        this.tags = res.tag ? res.tag[0]?.name : ''
        this.diff_fee_tag = res.diff_fee_tag
        this.pay_status = res.pay_status
        this.formData.sum_compute_price = res.money_answer
        // this.formData.is_by_stages = res.is_by_stages
        this.score_image = res.score_image
        this.order_type = res.order_type
        const list = [
          { label: '订单编号', value: res.order_number },
          { label: '入账学校', value: res.school },
          { label: res.order_type === 100 ? '订单类型' : '购买服务名称', value: res.order_type === 100 ? res.order_type_name : res.goods_pack_name },

          { label: '学生姓名', value: res.student_name },
          { label: '学生身份证号/护照号', value: res.student_idcard },
          { label: res.order_type === 100 ? '缴费学年' : '报名年级', value: res.order_type === 100 ? res.school_year : res.grade_name },
          ...(res.order_type === 100 ? [
            { label: '就读年级', value: res.grade_name },
            { label: '行政班', value: res.class_name },
            { label: '就读校区', value: res.studying_school_name },
            { label: '购买服务名称/收费项名称', value: res.goods_pack_name },
            { label: '开始收费时间', value: res.charge_at }
          ] : [])
        ]
        if (res.order_type === 2) {
          if (res.max_score_name === '中考') {
            list.push({ label: '中考成绩折算后总分', value: res.max_score })
            list.push({ label: '中考成绩截图', value: res.score_image ? '' : '-', button: res.score_image ? '查看成绩截图' : '', type: 0 })
          } else {
            list.push({ label: '最高诊断性考试折算后总分', value: res.max_score, button: '查看详情', type: 1 })
            this.dialogList = [
              { label: '学生姓名', value: res.student_name },
              { label: '学生参考城市', value: res.senior_city },
              { label: '考试名称', value: res.max_score_name },
              { label: '考试总分', value: res.junior_score },
              { label: '折算后考试总分', value: res.max_score }
            ]
          }
        }
        this.list = list
      })
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formData.is_pay === 2) {
            this.dialogVisible = true
            return
          }
          const arr = this.formData.payment_detail.filter((i) => i.paid_amount)
          const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount)), 0)
          const total = Number(this.formData.sum_compute_price)
          const actual = Number(this.formData.sum_price)
          let msg = ''
          // 1.分期/部分欠缴   实缴金额 !== sum
          // 2.不分期          应缴金额 !== sum
          if (this.showMethod) {
            if ((this.formData.is_by_stages && actual !== sum) || (!this.formData.is_by_stages && total !== sum)) {
              msg = `学生【实缴金额及方式】的累计实缴金额需等于【${this.order_type == 100 ? '实缴金额' : '合计实缴总额'}】`
            }
          }
          if (msg) return this.$message.error({ message: msg, duration: 4000 })
          if (this.diff_fee_tag && this.formData.is_pay === 1) {
            this.handleSure()
            return
          }
          this.dialogVisible = true
        }
      })
    },
    handleSure() {
      const { is_pay, is_by_stages, sum_price, sum_remain_price, average_price, installment_count, reason, remark, payment_detail, ...other } = this.formData
      const id = this.$route.query.id
      const data = is_pay === 1 ? { id, is_pay, is_by_stages, reason: remark, ...other } : { id, is_pay, reason }
      if (is_pay === 1) {
        const v = Number(sum_price)
        if (is_by_stages !== 0) {
          data.sum_price = v
          data.sum_first_price = v
          data.sum_remain_price = sum_remain_price
        }
        if (is_by_stages === 1) {
          const key = this.installmentConfig[installment_count - 1].prop
          data.goods_stages = [
            { 
              installment_count,
              compute_price: other.sum_compute_price,
              discount_price: 0,
              discount_year: 0,
              price: other.sum_compute_price,
              first_price: v,
              last_price: this.installmentData[0][key],
              average_price: Number(average_price)
            }
          ]
        }
        data.payment_detail = v ? transformAddOrEditData(payment_detail) : [
          {
            payment_method: '现金',
            paid_amount: 0,
            payer: '/',
            payment_at: formatDate().fullDateTime
          }
        ]
        data.payment_at = data.payment_detail[0].payment_at
      }
      http({ url: '/recruit-v2/order-offline/edit', pre: 'zs', method: 'post' }, data)
        .then((res) => {
          if (is_pay === 1 && this.diff_fee_tag && this.pay_status === 0) {
            return this.$router.replace('/finance/enrollment/score-difference-fee/edit?order_id=' + res.order_id)
          }
          this.$router.replace('/finance/enrollment/offline-payment-approval/look-old?id=' + this.$route.query.id)
        })
        .catch((err) => {
          // console.log(err)
        })
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleAdd() {
      if (this.dynamicMaxlength <= this.formData.payment_detail.length) {
        return this.$message.warning(`最多只能添加${this.dynamicMaxlength}条`)
      }
      this.formData.payment_detail.push({ id: Date.now(), payment_method: '', paid_amount: '', payer: '', payment_at: formatDate().fullDateTime, isAdd: 1 })
    },
    handleDelete(item) {
      const index = this.formData.payment_detail.indexOf(item)
      if (!~index) return
      this.formData.payment_detail.splice(index, 1)
    },
    handelRemove(item) {
      const { id, ...other } = item
      if (objectIsEmpty(other, ['isAdd'])) return this.handleDelete(item)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({ type: 'success', message: `删除成功!` })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-wrap {
  display: inline-block;
  padding: 2rem 6rem;
  background: #f0f0f0;
  border-radius: 4rem;
  font-size: 12rem;
  color: #f53f3f;
  background-color: #fce5e5;
}

.tips-info {
  margin-top: 10rem;
  padding: 0 10rem;
  background-color: #f4f4f5;
  color: #909399;
  font-size: 12rem;
  line-height: 30rem;
  display: inline-block;
  border-radius: 6rem;

  .z-i {
    margin-right: 4rem;
  }
}

.installment-tip-wrap {
  position: relative;
}

.installment-tip {
  position: absolute;
  left: 0;
  bottom: -34px;
}
</style>
